var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5573 21.5574H4.75729C3.4318 21.5574 2.35729 20.4828 2.3573 19.1574L2.35739 4.75741C2.3574 3.43193 3.43192 2.35742 4.75739 2.35742H15.5577C16.8831 2.35742 17.9577 3.43194 17.9577 4.75742V9.55742M6.55768 7.15742H13.7577M6.55768 10.7574H13.7577M6.55768 14.3574H10.1577M13.1575 18.2484L18.2487 13.1573L21.6428 16.5514L16.5516 21.6426H13.1575V18.2484Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.b5b8d4aa09122ef99949a6d936936fb6.svg";
export { ForwardRef as ReactComponent };